import React from "react";

export function SectionHeader({ label }: { label: string }) {
  return <div className="fn-us-section-header">{label}</div>;
}
